import { render } from "./ListaArquivos.vue?vue&type=template&id=159a246d"
import script from "./ListaArquivos.vue?vue&type=script&lang=js"
export * from "./ListaArquivos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__